import { Bell } from "lucide-react";
import Logo from "./Logo";
import AnnouncementBar from "./AnnouncementBar";

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Nav() {
  return (
    <header className="fixed top-0 inset-x-0 z-40" data-testid="site-nav">
      <AnnouncementBar />
      <div className="bg-[#F7F6F2]/80 backdrop-blur-md border-b border-[#111111]/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() =>
            window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.4 }) : window.scrollTo({ top: 0, behavior: "smooth" })
          }
          className="flex items-center gap-2 group"
          data-testid="nav-brand"
        >
          <Logo testid="nav-logo" className="h-9 w-9 transition-transform duration-300 group-hover:rotate-12" />
          <span className="font-serif text-xl md:text-2xl tracking-tight">My Fresh Tracker</span>
        </button>
        <nav className="hidden md:flex items-center gap-10">
          {[
            ["features", "Features"],
            ["support", "Support"],
            ["privacy", "Privacy"],
          ].map(([id, label]) => (
            <button
              key={id}
              onClick={() => scrollToSection(id)}
              data-testid={`nav-${id}-link`}
              className="uppercase tracking-[0.2em] text-xs font-semibold text-[#111111]/70 hover:text-[#1F9D55] transition-colors duration-300"
            >
              {label}
            </button>
          ))}
        </nav>
        <button
          onClick={() => scrollToSection("hero-notify-form")}
          data-testid="nav-notify-button"
          className="rounded-full bg-[#111111] text-[#F7F6F2] px-5 py-2.5 text-xs uppercase tracking-[0.2em] font-semibold hover:bg-[#1F9D55] transition-colors duration-300 flex items-center gap-2"
        >
          <Bell className="h-3.5 w-3.5" /> Notify me
        </button>
        </div>
      </div>
    </header>
  );
}
